import { useState, useEffect } from 'react'
import { useSubscription } from './useSubscription'

/**
 * Hook untuk mengelola akses agent berdasarkan subscription package
 * @param {string} agentType - Tipe agent yang akan dicek aksesnya
 * @returns {object} - Object berisi status akses dan informasi terkait
 */
export const useAgentAccess = (agentType) => {
  const { checkAgentAccess, hasActiveSubscription, loading } = useSubscription()
  const [accessStatus, setAccessStatus] = useState({
    hasAccess: false,
    loading: true,
    error: null,
    needsUpgrade: false,
    packageName: null,
    message: null
  })

  useEffect(() => {
    const checkAccess = async () => {
      if (loading) return
      
      if (!hasActiveSubscription) {
        setAccessStatus({
          hasAccess: false,
          loading: false,
          error: null,
          needsUpgrade: true,
          packageName: null,
          message: 'Anda perlu berlangganan untuk menggunakan fitur ini'
        })
        return
      }

      try {
        const result = await checkAgentAccess(agentType)
        
        // Debug logging for video_agent specifically
        if (agentType === 'video_agent') {
          console.log('🔍 [useAgentAccess] Video agent access check result:', {
            agentType,
            hasAccess: result.hasAccess,
            reason: result.reason,
            packageName: result.packageName,
            message: result.message,
            needsUpgrade: result.needsUpgrade
          })
        }
        
        setAccessStatus({
          hasAccess: result.hasAccess,
          loading: false,
          error: result.error || null,
          needsUpgrade: result.needsUpgrade || false,
          packageName: result.packageName || null,
          message: result.message || null
        })
      } catch (error) {
        console.error('Error checking agent access:', error)
        setAccessStatus({
          hasAccess: false,
          loading: false,
          error: error.message,
          needsUpgrade: true,
          packageName: null,
          message: 'Terjadi kesalahan saat memeriksa akses agent'
        })
      }
    }

    if (agentType) {
      checkAccess()
    }
  }, [agentType, checkAgentAccess, hasActiveSubscription, loading])

  return accessStatus
}

export default useAgentAccess